import { differenceInCalendarDays } from "date-fns";
import { getInvoiceEffectiveStatus } from "./accrual-source";
import { parseDateOnlyAsUTC } from "./date";
import { InvoiceSource, InvoiceStatus } from "../types/invoice";

interface InvoiceDaysOverdueInput {
    source: InvoiceSource;
    status: InvoiceStatus;
    externalStatus: InvoiceStatus | null;
    dueDateOnly: string | null;
}

/**
 * Days between `todayDateOnly` and the due date for an open invoice, 0 for
 * anything else (paid, draft, void, no due date, not yet due). Mirrors the
 * Invoicing tab's aging buckets: open is judged by the effective status and
 * the age is `NOW()`-based. Backend sort uses the same rule in SQL.
 */
export function getInvoiceDaysOverdue(
    invoice: InvoiceDaysOverdueInput,
    todayDateOnly: string,
): number {
    if (
        !invoice.dueDateOnly ||
        getInvoiceEffectiveStatus(invoice) !== InvoiceStatus.OPEN
    ) {
        return 0;
    }
    return Math.max(
        0,
        differenceInCalendarDays(
            parseDateOnlyAsUTC(todayDateOnly),
            parseDateOnlyAsUTC(invoice.dueDateOnly),
        ),
    );
}
